import React from 'react'

import { Portal } from 'components/layout'

import { default as StickyAnnouncement, StickyAnnouncementProps } from '../StickyAnnouncement/StickyAnnouncement'


export type PortalStickyAnnouncementProps = StickyAnnouncementProps

const PortalStickyAnnouncement: React.FC<PortalStickyAnnouncementProps> = (props) => {
  const { announcement, hash, withCloseButton } = props

  return (
    <Portal id="announcement">
      <StickyAnnouncement
        announcement={announcement}
        hash={hash}
        withCloseButton={withCloseButton}
      />
    </Portal>
  )
}


export default PortalStickyAnnouncement
